import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lead-managment',
  templateUrl: './lead-managment.component.html',
  styleUrls: ['./lead-managment.component.scss'],
})
export class LeadManagmentComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
